// import AnsibleTemplate from '@Compute/views/ansible-template'
// import AnsibleTemplateCreate from '@Compute/views/ansible-template/create'
import Layout from '@/layouts/RouterView'
import { setupKeys } from '@/utils/auth'
import i18n from '@/locales'
import { isScopedPolicyMenuHidden } from '@/utils/scopedPolicy'

const VmRelase = () => import(/* webpackChunkName: "helm" */ /* webpackPrefetch: true */ '@Helm/views/vm-release')
const VmReleaseUpdate = () => import(/* webpackChunkName: "helm" */ /* webpackPrefetch: true */ '@Helm/views/vm-release/update')
const K8sRelease = () => import(/* webpackChunkName: "helm" */ /* webpackPrefetch: true */ '@Helm/views/k8s-release')
const K8sReleaseUpdate = () => import(/* webpackChunkName: "helm" */ /* webpackPrefetch: true */ '@Helm/views/k8s-release/update')
const Chart = () => import(/* webpackChunkName: "helm" */ /* webpackPrefetch: true */ '@Helm/views/chart')
const K8sChartCreate = () => import(/* webpackChunkName: "helm" */ /* webpackPrefetch: true */ '@Helm/views/chart/create')
const Repo = () => import(/* webpackChunkName: "helm" */ /* webpackPrefetch: true */ '@Helm/views/repo')
const Scheduledtask = () => import(/* webpackChunkName: "helm" */ /* webpackPrefetch: true */ '@Cloudenv/views/scheduledtask')
const ScheduledtaskCreate = () => import(/* webpackChunkName: "helm" */ /* webpackPrefetch: true */ '@Cloudenv/views/scheduledtask/create')

// let Monitor = { meta: { hidden: true } }
// const modules = require.context('../../../containers', true, /^((?![\\/]node_modules).)*.\/router\/index.js$/)
// const moduleList = modules.keys()
// if ([].includes.call(moduleList, './Monitor/router/index.js')) {
//  Monitor = modules('./Monitor/router/index.js').default
// }

export default {
  index: 70,
  meta: {
    label: i18n.t('helm.text_1'),
    icon: 'menu-helm',
    catalog: 'other',
    undetected: true,
  },
  menus: [
    // Monitor,
    {
      meta: {
        label: i18n.t('helm.text_7'),
      },
      submenus: [
        {
          path: '/scheduledtask',
          meta: {
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.scheduledtask')) {
                return true
              }
              return process.env.VUE_APP_IS_PRIVATE
                ? !setupKeys.hasVersionedSetupKey({
                  '3.0': ['monitor'],
                  default: ['onestack', 'private', 'public', 'vmware'],
                })
                : false
            },
            label: i18n.t('helm.text_8'),
            permission: 'scheduledtasks_list',
          },
          component: Layout,
          children: [
            {
              name: 'Scheduledtasks',
              path: '',
              component: Scheduledtask,
            },
            {
              name: 'ScheduledtaskCreate',
              path: 'create',
              component: ScheduledtaskCreate,
            },
          ],
        },
        // {
        //   path: '/ansibletemplate',
        //   meta: {
        //     label: i18n.t('dictionary.ansibletemplate'),
        //     permission: 'ansible_devtool_templates_list',
        //   },
        //   component: Layout,
        //   children: [
        //     {
        //       name: 'AnsibleTemplate',
        //       path: '',
        //       component: AnsibleTemplate,
        //     },
        //     {
        //       name: 'AnsibleTemplateCreate',
        //       path: 'create',
        //       component: AnsibleTemplateCreate,
        //     },
        //   ],
        // },
      ],
    },
    {
      meta: {
        label: i18n.t('helm.text_2'),
      },
      submenus: [
        {
          path: '/vm-release',
          component: Layout,
          meta: {
            label: i18n.t('helm.text_3'),
            permission: 'k8s_releases_list',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.vm_release')) {
                return true
              }
              return process.env.VUE_APP_IS_PRIVATE
                ? !setupKeys.hasVersionedSetupKey({
                  '3.0': ['monitor'],
                  default: [
                    'onestack',
                    'openstack',
                    'dstack',
                    'zstack',
                    'public',
                    'k8s',
                    'vmware',
                    'hcso',
                    'hcs',
                  ],
                })
                : false
            },
            // invisible: () => true,
          },
          children: [
            {
              name: 'VmRelaseIndex',
              path: '',
              component: VmRelase,
            },
            {
              name: 'VmReleaseUpdate',
              path: 'update/:name',
              component: VmReleaseUpdate,
            },
          ],
        },
        {
          path: '/k8s-release',
          component: Layout,
          meta: {
            label: i18n.t('helm.text_4'),
            permission: 'k8s_releases_list',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.k8s_release')) {
                return true
              }
              return !setupKeys.hasAllVersionedSetupKey({
                '3.0': ['monitor', 'k8s'],
                default: ['k8s'],
              })
            },
            // invisible: () => true,
          },
          children: [
            {
              name: 'K8sRelaseIndex',
              path: '',
              component: K8sRelease,
            },
            {
              name: 'K8sReleaseUpdate',
              path: 'update/:id',
              component: K8sReleaseUpdate,
            },
          ],
        },
        {
          path: '/k8s-chart',
          meta: {
            label: i18n.t('helm.text_5'),
            permission: 'k8s_charts_list',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.k8s_chart')) {
                return true
              }
              return process.env.VUE_APP_IS_PRIVATE
                ? !setupKeys.hasVersionedSetupKey({
                  '3.0': ['monitor'],
                  default: [
                    'onestack',
                    'openstack',
                    'dstack',
                    'zstack',
                    'public',
                    'k8s',
                    'vmware',
                    'hcso',
                    'hcs',
                  ],
                })
                : false
            },
            // invisible: () => true,
          },
          component: Layout,
          children: [
            {
              name: 'K8sChartList',
              path: '',
              component: Chart,
            },
            {
              name: 'K8sChartCreate',
              path: 'create',
              component: K8sChartCreate,
            },
          ],
        },
        {
          path: '/k8s-repo',
          meta: {
            label: i18n.t('helm.text_6'),
            permission: 'k8s_repos_list',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.k8s_repo')) {
                return true
              }
              return process.env.VUE_APP_IS_PRIVATE
                ? !setupKeys.hasVersionedSetupKey({
                  '3.0': ['monitor'],
                  default: [
                    'onestack',
                    'openstack',
                    'dstack',
                    'zstack',
                    'public',
                    'k8s',
                    'vmware',
                    'hcso',
                    'hcs',
                  ],
                })
                : false
            },
            // invisible: () => true,
          },
          component: Layout,
          children: [
            {
              name: 'K8sRepoList',
              path: '',
              component: Repo,
            },
          ],
        },
      ],
    },
  ],
}
